import moment from 'moment-timezone'

export default ({ timestamp, previousTimestamp }) => {
  if (!previousTimestamp) return null

  return moment(previousTimestamp.timestamp).diff(timestamp.timestamp)
}
